{
  "login": "Login",
  "logout": "Logout",
  "signOut": "Sign out",
  "username": "Username",
  "password": "Password",
  "forgotPassword": "Forgot Password?",
  "rememberMe": "Remember me",
  "loginButton": "Sign In",
  "loginError": "Invalid username or password",
  "sessionExpired": "Your session has expired. Please login again.",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "Signing in...",
  "loginSuccess": "Login successful",
  "showPassword": "Show password",
  "hidePassword": "Hide password",
  "onboardingPrompt": "For your hospital or clinic?",
  "onboardingCta": "Request onboarding",
  "loginFailed": "Login failed",
  "seatCapReached": "User limit reached for this license. Contact your administrator.",
  "mfaCodeLabel": "Verification code",
  "mfaCodePrompt": "Enter the 6-digit code from your authenticator app to finish signing in.",
  "mfaSetupRequired": "Your organization requires multi-factor authentication. Set up your authenticator app to continue.",
  "mfaCodePlaceholder": "6-digit code",
  "mfaInvalidCode": "Invalid verification code",
  "pages": {
    "userProfile": {
      "title": "My Profile",
      "loading": "Loading profile...",
      "sections": {
        "profilePicture": "Profile Picture",
        "personalInformation": "Personal Information",
        "changePassword": "Change Password",
        "multiFactorAuth": "Multi-Factor Authentication"
      },
      "fields": {
        "fullName": "Full Name",
        "email": "Email",
        "phone": "Phone",
        "currentPassword": "Current Password",
        "newPassword": "New Password",
        "confirmPassword": "Confirm New Password",
        "required": "*"
      },
      "actions": {
        "saveChanges": "Save Changes",
        "changePassword": "Change Password",
        "setUpMfa": "Set Up MFA",
        "uploadAvatar": "Upload",
        "changeAvatar": "Change",
        "removeAvatar": "Remove",
        "verify": "Verify"
      },
      "avatar": {
        "alt": "Avatar",
        "helperText": "PNG, JPEG or WebP up to 4 MB. Resized to {{size}}×{{size}} before upload."
      },
      "mfa": {
        "enabledMessage": "MFA is enabled on your account.",
        "intro": "Add an extra layer of security to your account by enabling multi-factor authentication.",
        "scanInstruction": "Scan this URI with your authenticator app, or copy it manually:",
        "copyUri": "Copy URI",
        "verificationCode": "Verification Code",
        "codePlaceholder": "Enter 6-digit code"
      },
      "validation": {
        "fullNameRequired": "Full name is required",
        "emailRequired": "Valid email is required",
        "currentPasswordRequired": "Current password is required",
        "newPasswordTooShort": "Password must be at least 8 characters",
        "confirmPasswordRequired": "Please confirm your password",
        "passwordsMismatch": "Passwords do not match"
      },
      "toasts": {
        "profileUpdated": "Profile updated successfully",
        "profileUpdateFailed": "Failed to update profile",
        "passwordChanged": "Password changed successfully",
        "passwordChangeFailed": "Failed to change password. Please check your current password.",
        "mfaSetupFailed": "Failed to initiate MFA setup",
        "mfaEnabled": "MFA enabled successfully",
        "mfaInvalidCode": "Invalid verification code",
        "avatarUpdated": "Avatar updated",
        "avatarUpdateFailed": "Failed to update avatar",
        "avatarRemoved": "Avatar removed",
        "avatarRemoveFailed": "Failed to remove avatar",
        "imageTooLarge": "Image must be under 4 MB",
        "imageTooLargeServer": "Image is too large — try a smaller file",
        "copiedToClipboard": "Copied to clipboard"
      },
      "__review_mfa": "MFA labels: APAC jurisdictions may use alternate terminology (e.g. two-factor authentication, 2FA, multi-step verification). Review with regional clinical IT leads."
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "Your session expires in less than 1 minute. Save your work now.",
      "expiringSoon_one": "Your session expires in {{count}} minute.",
      "expiringSoon_other": "Your session expires in {{count}} minutes.",
      "extendButton": "Extend Session"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "Initial setup",
    "subtitle": "Create the first administrator account for this installation.",
    "username": "Username",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "fullName": "Full name (optional)",
    "fullNamePlaceholder": "e.g. Tan Wei Ming",
    "email": "Email (optional)",
    "submit": "Create administrator account",
    "submitting": "Creating account…",
    "usernameHint": "3–64 characters: lowercase letters, digits, dots, underscores and hyphens.",
    "passwordHint": "At least 12 characters, with uppercase, lowercase, digit and special character.",
    "errUsername": "Use 3–64 characters: a–z, 0–9, dot, underscore or hyphen.",
    "errPasswordLength": "Password must be at least 12 characters.",
    "errPasswordUpper": "Password must contain an uppercase letter.",
    "errPasswordLower": "Password must contain a lowercase letter.",
    "errPasswordDigit": "Password must contain a digit.",
    "errPasswordSpecial": "Password must contain a special character.",
    "errConfirmRequired": "Please confirm the password.",
    "errConfirmMismatch": "Passwords do not match.",
    "errFullName": "Full name must be 100 characters or fewer.",
    "errEmail": "Enter a valid email address.",
    "successTitle": "Administrator account created",
    "successBody": "Account “{{username}}” is ready. Sign in to continue.",
    "goToLogin": "Go to sign-in",
    "claimedTitle": "Setup already completed",
    "claimedBody": "This system already has an administrator. Sign in with your account.",
    "networkError": "Could not reach the server. Check your connection and try again.",
    "retry": "Retry",
    "rateLimited": "Too many attempts. Wait a minute and try again.",
    "usernameTaken": "This username is already taken.",
    "submitFailed": "Could not create the account. Please try again."
  }
}
